import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import ButtonDash from "../common/buttonDashboard";
import BranchContext from "../context/branch";
import {
  getWaitPaylist,
 
} from "./../../services/car";
import Renderwaitting from "./renderwaitlist";
import ScrollToTop from "../common/ScrollToTop";
import DatePicker from "react-datepicker";
import PrivilegeContext from "../context/privilege";
import Input from "../common/inputfunction";
import Select from "../common/selectcustom";
import moment from "moment";

const Waitpaylist = (props) => {
  const { currentBranch } = useContext(BranchContext);
  const {menuItems} = useContext(PrivilegeContext);
  const [startDate, setStartDate] = useState(new Date());
  const [value, setValue] = useState(0);
  const [waiting, setwaiting] = useState([]);
  const [askConfirm, setaskConfirm] = useState(false);
  const [askDisagree, setaskDisagree] = useState(false);
  const [message, setmessage] = useState("");
  const [messageerror, setmessageerror] = useState("");
  const [remark, setremark] = useState("");
  const [Id, setId] = useState("");
  const [saveSuccess, setsaveSuccess] = useState(false);
  const [searchID, setSearchID] = useState("");
  const [search, setsearch] = useState("");
  const [drivenno, setdrivenno] = useState("");

  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [pageSize, setPageSize] = useState(30);
  const [data, setData] = useState([]);
  const [statuslist, setStatuslist] = useState([]);
  const [permitetypelist, setPermiteTypelist] = useState([]);
  const [arealist, setarealist] = useState([]);
  const [areaid, setareaid] = useState(0);
  const [endDate, setEndDate] = useState(new Date());
  const [permitId, setpermitId] = useState(0);
  const [statusId, setStatusId] = useState("0");
  const [lastcheck, setlastcheck] = useState(new Date());
  const [companyname, setcompanyname] = useState("");
  const [comsearch, setcomsearch] = useState("");
  const [drivensearch, setdrivensearch] = useState("");
  const [total, setTotal] = useState({ total: 0, dis: 0, app: 0, wait: 0 });
  const [showonscroll, setshowonscroll] = useState(false);
  const [chkowner, setchkowner] = useState(false);
  const [oncheck, setoncheck] = useState(false);
  const [onprocess, setonprocess] = useState(false);
  const [list, setlist] = useState([]);
  const [formload, setformload] = useState(false);

  useEffect(() => {
    if (!currentBranch) return;

    setwaiting([]);
  }, [
    currentBranch,
    pageNumber,
    menuItems,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!menuItems) return;
    if (menuItems.length === 0) return;
   
    setLoading(true);
    setError(false);

    const loadRegister = async () => {
      const { data: result } = await getWaitPaylist(
        1,
        pageSize,
        pageNumber
      );

      if (result.status === "success") {
      

        setwaiting((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      } 
    };

    loadRegister();
  }, [
    currentBranch,
    pageNumber,
    pageSize,
    menuItems,
  ]);









  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );





  

 




  const clearmessage = () => {
    setmessage("");
    setmessageerror("");
  };

 



const handleClick = () => {
  
}

 





  return (
    <div className="container-fluid">
     

      <div className="container-fluid">

      <h3 className="text-primary">
       รายชื่อล๊อคที่ค้างจ่าย
      </h3>
      </div>

      <p className="text-success">
        แสดงข้อมูล {waiting ? waiting.length : 0}  รายการ
      </p>

      {<ScrollToTop />}
      <Renderwaitting
        list={waiting}
        loading={loading}
        error={error}
        lastBookElementRef={lastBookElementRef}
         handleChange={handleClick}
      />
    </div>
  );
};

export default Waitpaylist;
